import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import { getMedicalAidsReference } from "../../api";

export default function MedicalAidsReferenceModal({ show, onHide }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    if (!show || rows.length) return;
    setLoading(true);
    getMedicalAidsReference()
      .then(setRows)
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, [show]);

  const lower = filter.toLowerCase();
  const visible = lower
    ? rows.filter(
        (r) =>
          (r.SCHEME || "").toLowerCase().includes(lower) ||
          (r["OPTION CODE"] || "").toLowerCase().includes(lower) ||
          (r["CLAIM TYPE"] || "").toLowerCase().includes(lower),
      )
    : rows;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton className="border-secondary">
        <Modal.Title className="text-primary fs-5">
          Medical Aids Reference
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          placeholder="Search scheme or option code..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="mb-3"
          size="sm"
        />
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" size="sm" className="me-2" />
            Loading…
          </div>
        ) : (
          <Table striped bordered hover size="sm" style={{ fontSize: "0.82rem" }}>
            <thead className="table-dark">
              <tr>
                <th>Scheme</th>
                <th>Claim Type</th>
                <th>Option Code</th>
              </tr>
            </thead>
            <tbody>
              {visible.map((r, i) => (
                <tr key={i}>
                  <td>{r.SCHEME}</td>
                  <td>{r["CLAIM TYPE"]}</td>
                  <td>
                    <code>{r["OPTION CODE"]}</code>
                  </td>
                </tr>
              ))}
              {!visible.length && (
                <tr>
                  <td colSpan={3} className="text-center text-muted">
                    No results
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
}
